import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { addMetamaskFailure, addMetamaskSuccess } from "./actions";
import { addMetamaskActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { prepareMetamask } from "@helpers/metamask";
import { setProfile } from "../profile/actions";
import ToastService from "../../services/ToastService";

const addMetamaskAsync = ({ SocialsService, address, signature }) => {
  if (!SocialsService) {
    console.log("Required services does not exist");
    return null;
  }

  return SocialsService.connectMetamask({ address, signature });
};

function* addMetamask() {
  try {
    const { SocialsService } = yield getContext(CONTEXT.SERVICES);
    const { address, signature } = yield call(prepareMetamask);

    yield call(addMetamaskAsync, { SocialsService, address, signature });

    yield put(setProfile({ isMetamaskConnected: true }));
    yield put(addMetamaskSuccess({ address }));
  } catch ({ error }) {
    ToastService.error(error?.message);
    yield put(addMetamaskFailure(error));
  }
}

export function* watchAddMetamask() {
  yield takeEvery(addMetamaskActionTypes.request, addMetamask);
}
